var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTreesBushes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 681.891,
    height: 63.67,
    viewBox: "0 0 681.891 63.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trees-bushes",
    transform: "translate(-387 -4425.328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3007",
    "data-name": "Path 3007",
    d: "M230.889,63.665H23a34.938,34.938,0,0,1,51.045-30.74,58.954,58.954,0,0,1,105.8,0,34.943,34.943,0,0,1,51.046,30.739Z",
    transform: "translate(700 4425.334)",
    fill: "#5d7e63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3008",
    "data-name": "Path 3008",
    d: "M230.889,63.665H23a34.938,34.938,0,0,1,51.045-30.74,58.954,58.954,0,0,1,105.8,0,34.943,34.943,0,0,1,51.046,30.739Z",
    transform: "translate(364 4425.334)",
    fill: "#c4d5c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3009",
    "data-name": "Path 3009",
    d: "M230.889,63.665H23a34.938,34.938,0,0,1,51.045-30.74,58.954,58.954,0,0,1,105.8,0,34.943,34.943,0,0,1,51.046,30.739Z",
    transform: "translate(838 4425.334)",
    fill: "#c4d5c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3010",
    "data-name": "Path 3010",
    d: "M230.889,63.665H23a34.938,34.938,0,0,1,51.045-30.74,58.954,58.954,0,0,1,105.8,0,34.943,34.943,0,0,1,51.046,30.739Z",
    transform: "translate(535 4425.334)",
    fill: "#eaf2ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3011",
    "data-name": "Path 3011",
    d: "M230.889,63.665H23a34.938,34.938,0,0,1,51.045-30.74,58.954,58.954,0,0,1,105.8,0,34.943,34.943,0,0,1,51.046,30.739Z",
    transform: "translate(456 4425.334)",
    fill: "#5d7e63"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreesBushes);
export default __webpack_public_path__ + "static/media/trees-bushes.deec225d42678a9fa216604de65642f3.svg";
export { ForwardRef as ReactComponent };